import template from './form.text-input.html';

// <tc-text-input>
export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.form.text-input',
    []
  )
  .component('tcTextInput', {
    template,
    require: {
      form: '?^^form',
    },
    bindings: {
      me: '<',
      data: '<',
      fields: '<',
      element: '<',
      disabled: '<',
      elementStyle: '<',
    },
    controller: function () {
      this.$onInit = function() {
        // Ensure bindings are available before accessing them
        if (this.fields && this.element && this.element.name) {
          this.field = this.fields[this.element.name];
        } else {
          console.warn('TextInput: fields or element not available');
        }
      };

      this.isFieldDisabled = () => {
        return (
          !this.me ||
          !(this.field.editBy === this.me.type || !this.field.editBy)
        );
      };
    },
  }).name;
